module.exports = __webpack_public_path__ + "static/media/orari_blue.1623eb8a.png";